import axios from 'axios';
import data from '../../data/config.json'
import Cookies from 'universal-cookie';
const API_URL = `${data.api_url}`
axios.defaults.withCredentials = true
const cookies = new Cookies();
const auth_cookies = cookies.get('connect.dreamvast')
console.log("Api " + auth_cookies)

export async function PostLang(id: any, req_body: string) {
  const post_body = { language: req_body } 
  await axios.post(`${API_URL}/guilds/${id}/settings/language`, post_body, {
    headers: { Authorization: `${auth_cookies ? auth_cookies : null}` }
  })
}